import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import InterventionPrivateApiModel from 'modelx/models/abstracts/InterventionPrivateApiModel';

@model.staticLabel('Référence de méthode', false)
@model.urnResource('measure_methodology')
@doc.path('/measure_methodologies/{?id}')
export default class MeasureMethodologyModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'measureMethodologyPartitions': id;
		'measureMethodologyPartitions.ownerPartition': id;
		'measureMethodologyPartitions.ownerPartition.partitionUrn': Urn;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare label: string;
}